/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AOCCompeteOrderUpdateDto,
  BooleanResponseWrapper,
  PageantAvailableAOCAddEditDTO,
  PageantAvailableEventModel,
  PageantAvailableEventModelResponseWrapper,
  RegisteredContestantSelectedEventBaseModel,
  RegisteredContestantSelectedEventBaseModelResponseWrapper,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PageantAvailableEvent<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name GetPageantAvailableEventId
   * @request GET:/PageantAvailableEvent/{pageantAvailableEventId}
   */
  getPageantAvailableEventId = (pageantAvailableEventId: number, params: RequestParams = {}) =>
    this.request<PageantAvailableEventModel, any>({
      path: `/PageantAvailableEvent/${pageantAvailableEventId}`,
      method: 'GET',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name DeletePageantAvailableEvent
   * @request DELETE:/PageantAvailableEvent/{pageantAvailableEventId}
   */
  deletePageantAvailableEvent = (pageantAvailableEventId: number, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantAvailableEvent/${pageantAvailableEventId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name AddPageantAvailableAoc
   * @request POST:/PageantAvailableEvent/AddPageantAvailableAOC/{pageantId}
   */
  addPageantAvailableAoc = (pageantId: number, data: PageantAvailableAOCAddEditDTO, params: RequestParams = {}) =>
    this.request<PageantAvailableEventModelResponseWrapper, any>({
      path: `/PageantAvailableEvent/AddPageantAvailableAOC/${pageantId}`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name UpdatePageantAvailableAoc
   * @request POST:/PageantAvailableEvent/UpdatePageantAvailableAOC/{pageantId}/{eventId}
   */
  updatePageantAvailableAoc = (
    pageantId: number,
    eventId: number,
    data: PageantAvailableAOCAddEditDTO,
    query?: {
      replacePackages?: boolean;
    },
    params: RequestParams = {}
  ) =>
    this.request<PageantAvailableEventModelResponseWrapper, any>({
      path: `/PageantAvailableEvent/UpdatePageantAvailableAOC/${pageantId}/${eventId}`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name DeletePageantAvailableAoc
   * @request DELETE:/PageantAvailableEvent/DeletePageantAvailableAOC/{pageantId}/{eventId}
   */
  deletePageantAvailableAoc = (pageantId: number, eventId: number, params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/PageantAvailableEvent/DeletePageantAvailableAOC/${pageantId}/${eventId}`,
      method: 'DELETE',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name UpdateAocCompeteOrderCreate
   * @request POST:/PageantAvailableEvent/UpdateAOCCompeteOrder
   */
  updateAocCompeteOrderCreate = (data: AOCCompeteOrderUpdateDto[], params: RequestParams = {}) =>
    this.request<void, any>({
      path: `/PageantAvailableEvent/UpdateAOCCompeteOrder`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name SavePageantAvailableEvent
   * @request POST:/PageantAvailableEvent/Save
   */
  savePageantAvailableEvent = (data: PageantAvailableEventModel, params: RequestParams = {}) =>
    this.request<PageantAvailableEventModelResponseWrapper, any>({
      path: `/PageantAvailableEvent/Save`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name SelectAoc
   * @request POST:/PageantAvailableEvent/AOCSelection
   */
  selectAoc = (data: RegisteredContestantSelectedEventBaseModel, params: RequestParams = {}) =>
    this.request<RegisteredContestantSelectedEventBaseModelResponseWrapper, any>({
      path: `/PageantAvailableEvent/AOCSelection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name DeleteAocSelection
   * @request DELETE:/PageantAvailableEvent/AOCSelection/{aocSelectionId}
   */
  deleteAocSelection = (aocSelectionId: number, params: RequestParams = {}) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantAvailableEvent/AOCSelection/${aocSelectionId}`,
      method: 'DELETE',
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name PackageAssociationWithAoc
   * @request POST:/PageantAvailableEvent/PackageAssociationWithAOC
   */
  packageAssociationWithAoc = (
    data: number[],
    query?: {
      /** @format int32 */
      eventId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<void, any>({
      path: `/PageantAvailableEvent/PackageAssociationWithAOC`,
      method: 'POST',
      query: query,
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags PageantAvailableEvent
   * @name DeletePackageAssociationWithEvent
   * @request DELETE:/PageantAvailableEvent/PackageAssociationWithEvent/{pageantAvailableEventId}/{pageantAvailablePackageId}
   */
  deletePackageAssociationWithEvent = (
    pageantAvailableEventId: string,
    pageantAvailablePackageId: string,
    query?: {
      /** @format int32 */
      packageAssociationId?: number;
    },
    params: RequestParams = {}
  ) =>
    this.request<BooleanResponseWrapper, any>({
      path: `/PageantAvailableEvent/PackageAssociationWithEvent/${pageantAvailableEventId}/${pageantAvailablePackageId}`,
      method: 'DELETE',
      query: query,
      format: 'json',
      ...params,
    });
}
